const requireAll = requireContext => requireContext.keys().map(requireContext)
const global = require.context('./global', false)
const newGlobal = require.context('./newGlobal', false)

requireAll(global)
requireAll(newGlobal)
